<template>
  <div class='aftersales'>
    <div class="row">
      
    
      <div class='operation-bar col-6'>
        <p class="text-secondary">打印厂：请关注 <span class="text-danger">待处理售后</span> ，需要处理的订单请订单号并改成售后状态</p>
        <p class="text-secondary">打印厂：如果售后责任方归属为客户， 请在订单页面扣除重新制作的费用</p>
        <p class="text-secondary">客户：请关注 <span class="text-success">已处理售后</span> ，确认已处理后请回复客户并及时关闭售后</p>
      </div>

      <div class="col-6" v-if="report">
        <b-table striped hover :items="reportData" :fields="reportFields"></b-table>
      </div>
    </div>
    <div class="float-right mr-4">
      <button-group
        :p-button-group="salesGroup">
      </button-group>
    </div>
    
    <pager v-bind:items='this.aftersales || []'></pager>
    <div>
      <!-- Modal Component -->
      <b-modal 
        id="aftersale-detail" 
        ref="imageModalRef"
        size="md" 
        :title="activeModal.title"
        @shown="showViewer"
        no-fade>
        
        <p class="text-secondary small">
          <span class="text-primary">
            <b-img rounded width="20" height="20" class="m-1" :src='activeModal.creator.avatar' /> {{activeModal.creator.name}} 
          </span>发起于 <local-time :time="activeModal.create_at"></local-time></p>
        <p>{{activeModal.content}}</p>
        <ul class="list-group" id="image-viewer1">
          <li class="list-group-item" v-for='pic of activeModal.pic_list' :key="pic">
            <a href="#">
              <img class="w-100 d-inline-block" :src='pic'>
            </a>
          </li>
        </ul>
        <!-- 下面是回复内容 -->
        <hr>
        <b-card class="mb-5" v-for='(reply, index) in activeModal.replys' :key="index">
          <p class="card-text">
            <span class="text-secondary small">
              <b-img rounded width="20" height="20" class="m-1" :src='activeModal.creator.avatar' />{{reply.replier.name}} 回复于 <local-time :time="reply.create_at"></local-time>
            </span>
            <br><br>
            {{reply.content}}
          </p>
          <ul id="image-viewer2">
            <li v-for='pic of reply.pic_list' :key="pic">
              <img class="w-50 d-inline-block p-3" :src='pic'>
            </li>
          </ul>
        </b-card>
      </b-modal>
    </div>

    <div class="">

      <div v-if="failedCompanyOrderNos.length">
        <div class="alert alert-danger" role="alert">
          部分订单无法显示: {{failedCompanyOrderNos.join(",")}}， 请联系管理员！！
        </div>
      </div>
      <table class='table table-sm table-hover'>
        <thead class='thead-default'>
          <th nowrap>售后ID</th>
          <th nowrap>关联订单号</th>
          <th nowrap>状态</th>
          <th nowrap>优先级</th>
          <th nowrap>标题</th>
          <th nowrap>内容</th>
          <th nowrap>创建者</th>
          <th nowrap>处理人</th>
          <th nowrap>管理员留言</th>
          <th nowrap>创建时间</th>
          <th nowrap>更新时间</th>
          <th nowrap>操作</th>
        </thead>
        <tbody>
          <tr v-for='aftersale of this.aftersales'>
            <td nowrap>
              <span>{{ aftersale.id }}</span>
            </td>
            <td nowrap><a target="_blank" :href="'/orders?company_order_no=' + aftersale.local_order.company_order_no">{{ getCompanyDisplay(aftersale.local_order.company_code) }}-{{ aftersale.local_order.company_order_no }}</a></td>
            <td nowrap class="text-warning"><span :class="aftersale.local_order.status|orderStatusColor">{{aftersale.local_order.status|orderStatus}}</span></td>
            <td>{{ aftersale.priority|priorityStatus }}</td>
            <td nowrap><a href="#" class="text-primary" @click="activeModal = aftersale" v-b-modal.aftersale-detail>{{aftersale.title|textLimit}}</a></td>
            <td>{{ aftersale.content|afterSaleStatus }}</td>
            <td nowrap>{{aftersale.creator.name}}</td>
            <td nowrap>{{aftersale.handler.name}}</td>
            <td class="text-danger mw-50 small">{{aftersale.local_order.admin_notes}}</td>
            <td><local-time :time="aftersale.create_at"></local-time></td>
            <td><local-time :time="aftersale.update_at"></local-time></td>
            <td>
              <span v-if="aftersale.local_order.status==='sent'">
                <create-after-sale :order='aftersale.local_order'></create-after-sale>
              </span>
            </td>
          </tr>
        </tbody> 
      </table>
    </div>
    <div class="alert alert-primary cart" role="alert" v-if="selectedIds.length" >
      <div>您选中了{{selectedIds.length}}个订单</div>
      <div v-for="size, type in size">{{type}}: {{size}}</div>
      <div v-for="companyaftersaleNo in selectedDisplays">
        <div>{{companyaftersaleNo}}</div>
      </div>
    </div>   
  </div>
</template>

<script>
import Pager from './_partial/Pager'
import InputMixin from '@/mixins/input'
import {getHostName} from '@/utils/tools'
import OrderMixin from '@/mixins/order'
import LocalTime from '@/components/_small/LocalTime'
import CreateAfterSale from '@/components/_small/CreateAfterSale'
import ButtonGroup from '@/components/_partial/ButtonGroup'
import Viewer from 'viewerjs'
import LoadDataMixin from '@/mixins/load_data'

function getOpenidByHost () {
  var hostName = getHostName()
  var openid = ''
  if (hostName === 'yinjie') {
    openid = 'oi7rhjlfOruwxHyi2P8uVcJZ619s'
  } else if (hostName === 'yc') {
    openid = 'oi7rhjrk4WPjjlhziuWDOCgA3_fY'
  } else if (hostName === 'yyd') {
    openid = 'oi7rhjrXnESVdDQV7733a8A5SOPM'
  } else if (hostName === 'gs') {
    openid = 'oi7rhjt_h3J1OGcbEIyN1KHWRdEA'
  } else if (hostName === 'kl') {
    openid = 'oi7rhjoTFJuOyyMec7GupewO_eZs'
  } else {
    openid = 'oi7rhjlfOruwxHyi2P8uVcJZ619s'  // 用于测试 先锋的openid oi7rhjoGUKfLtAknINW1zoy3JZtk
  }
  return openid
}

function showViewer () {
  if (this.viewer1) {
    this.viewer1.destroy()
  }
  this.viewer1 = new Viewer(document.getElementById('image-viewer1'))
}

function loadData (query = null) {
  let page = this.$route.query.page || '1'
  let size = this.$route.query.size || '20'
  let status = this.$route.query.status

  let url = `https://weixinshu.com/v2/manager/helpdesk/requests/issue?openid=${getOpenidByHost()}&page=${page}&page_size=${size}`
  if (status) {
    url = url + `&status=${status}`
  }

  this.$http.get('/api/proxy?use_cache=false&url=' + encodeURIComponent(url)).then(response => {
    this.pre_aftersales = response.data.data.data
    let companyOrderNos = []
    for (let index in this.pre_aftersales) {
      this.pre_aftersales[index].create_at = new Date(this.pre_aftersales[index].create_at)
      companyOrderNos.push(this.pre_aftersales[index].category_info.trim())
    }
    this.fetchLocalOrderInfo(companyOrderNos)
  })
  .catch(function (error) {
    console.log(error)
  })
  this.fetchAftersales()
}

function fetchLocalOrderInfo (companyOrderNos) {
  if (companyOrderNos.length === 0) {
    return
  }

  this.$http.get('/api/orders?company_order_no__in=' + companyOrderNos.join(',')).then(response => {
    let orders = response.data.data
    for (let i in orders) {
      orders[i].sent_at = new Date(orders[i].sent_at)
      for (let j in this.pre_aftersales) {
        if (String(this.pre_aftersales[j].category_info).trim() === String(orders[i].company_order_no)) {
          if (orders[i].status === 'sent' && orders[i].sent_at > this.pre_aftersales[j].create_at) {
            orders[i].status = 'aftersale_done'
          }
          this.pre_aftersales[j].local_order = orders[i]
          break
        }
      }
    }

    this.aftersales = []
    for (let item of this.pre_aftersales) {
      if (item.local_order) {
        this.aftersales.push(item)
      } else {
        this.failedCompanyOrderNos.push(item.category_info)
      }
    }
  })
}

function fetchAftersales () {
  this.$http.get('/api/reports/after_sales').then(res => {
    this.report = res.data.data

    const this_month = this.report.this_month
    const past6 = this.report.past180


    this.reportData = [
    {
      company: '微信书',
      thisMonth: this_month.xin_count,
      thisMonthAftersales: this_month.xin_after_sales,
      thisMonthRate: computeRate(this_month.xin_after_sales, this_month.xin_count),
      past6: past6.xin_count,
      past6Aftersales: past6.xin_after_sales,
      past6Rate: computeRate(past6.xin_after_sales, past6.xin_count)
    },
    {
      company: '非微信书',
      thisMonth: this_month.non_xin_count,
      thisMonthAftersales: this_month.non_xin_after_sales,
      thisMonthRate: computeRate(this_month.non_xin_after_sales, this_month.non_xin_count),
      past6: past6.non_xin_count,
      past6Aftersales: past6.non_xin_after_sales,
      past6Rate: computeRate(past6.non_xin_after_sales, past6.non_xin_count)
    }]
  })
}

function computeRate(a, b) {
  const rate = (b == 0 ? 0 : a / b)

  return `${Math.round(rate * 100000) / 1000}%`

}

export default {
  name: 'aftersales',
  mixins: [InputMixin, OrderMixin, LoadDataMixin],
  data () {
    return {
      report: null,
      aftersales: [],
      reportFields: [{
        key: 'company',
        label: '公司'
      },
      {
        key: 'thisMonth',
        label: '当月订单数'
      },
      {
        key: 'thisMonthAftersales',
        label: '当月售后数'
      },
      {
        key: 'thisMonthRate',
        label: '当月售后率'
      },
      {
        key: 'past6',
        label: '前6个月订单数'
      },
      {
        key: 'past6Aftersales',
        label: '前6个月售后数'
      },
      {
        key: 'past6Rate',
        label: '前6个月售后率'
      }],
      report: null,
      reportData: null,
      failedCompanyOrderNos: [],
      activeModal: {
        creator: {}
      },
      salesGroup: {
        name: '未完成',
        value: '',
        key: 'status',
        menus: [{
          name: '未完成',
          value: ''
        },{
          name: '已关闭',
          value: '4'
        }]
      }
    }
  },
  components: {
    Pager,
    LocalTime,
    CreateAfterSale,
    ButtonGroup
  },
  mounted () {
    this.loadData()
  },
  filters: {
    textLimit: function (value) {
      return value.substr(0, 15) + '...'
    },
    afterSaleStatus: function (value) {
      return (value === 1) ? '待处理' : '处理中'
    },
    orderStatus: function (value) {
      if (value === 'sent') {
        return '待处理售后'
      } else if (value === 'post_sale') {
        return '已在售后处理'
      } else if (value === 'aftersale_done') {
        return '售后处理完毕'
      } else {
        return '已在售后处理'
      }
    },
    priorityStatus: function (value) {
      if (value === 3) {
        return '爆炸💥'
      } else if (value === 2) {
        return '紧急'
      } else {
        return '中等'
      }
    },
    orderStatusColor: function (value) {
      if (value === 'sent') {
        return 'text-danger'
      } else if (value === 'post_sale') {
        return 'text-warning'
      } else if (value === 'aftersale_done') {
        return 'text-success'
      } else {
        return 'text-warning'
      }
    }
  },
  methods: {
    loadData,
    fetchLocalOrderInfo,
    showViewer,
    fetchAftersales
  }
}
</script>

<style lang='scss' scoped>
  .cart {
    position: fixed;
    width: 350px;
    right: 20px;
    bottom: 20px;
    overflow-y: auto;
    max-height: 30%;
    z-index: 1000;
  }
</style>